import * as React from 'react';
import { Icon, Popover, Input } from 'antd';
import ComponentBasic from 'kts-scaffold-framework/component/ComponentBasic';
import ChatPanelProps from './ChatPanelProps';
import ChatPanelState from './ChatPanelState';

const css = require('./index.scss');

class UIEmailStart {
    /** 释放显示菜单 */
    public visible: boolean = false;
}

interface UIEmailProps {
}

/** 聊天面板组件 */
export default class UIEmail extends ComponentBasic<UIEmailProps, UIEmailStart> {

    state = new UIEmailStart();

    constructor(props: UIEmailProps) {
        super(props);
    }

    render() {
        return (
            <Popover overlayClassName={css['email-popover']} placement="topLeft" content={this.dropdownMenu} visible={this.state.visible} trigger="click" onVisibleChange={this.handleVisibleChange}>
                <Icon className={`${css.tianjialianxiren}`} type="tianjialianxiren" />
            </Popover>
        );
    }

    private handleVisibleChange = (visible) => {
        this.setState({ visible });
    }

    private get dropdownMenu() {
        return (
            <div className={`${css['dropdown-menu']}`} >
                <Input placeholder="请输入联系人邮箱" />
            </div>
        );
    }
}




// WEBPACK FOOTER //
// ./src/node_modules/kts-platform-frame/display/components/ChatPanel/UI.Email.tsx